export default __webpack_public_path__ + "static/homepage-supplier1-be6dcc96f8fbf0854afe45c873a915f0.png";